/**
 * Assignment Scan Types
 * Типы для модуля "Сканы назначений" — сканирование лекарств по назначениям DamuMed
 */

/**
 * Статусы синхронизации
 */
export enum AssignmentScanSyncStatus {
  PENDING = 'pending',
  SYNCED = 'synced',
  FAILED = 'failed',
}

/**
 * Основная модель сканирования назначения
 */
export interface AssignmentScan {
  id: string;
  tenant_id: string;
  employee_id: string;
  employee_name: string;
  patient_iin: string;
  patient_name?: string | null;
  in_patient_id: number;
  drug_assignment_id: number;
  drug_name: string;
  gtin: string;
  serial_number?: string | null;
  batch_number?: string | null;
  barcode_type: string;
  scanned_at: string;
  raw_code?: string | null;
  sync_status: AssignmentScanSyncStatus;
  sync_error?: string | null;
  synced_at?: string | null;
  created_at: string;
  updated_at: string;
}

/**
 * Фильтры для поиска сканирований назначений
 */
export interface AssignmentScanFilters {
  patient_iin?: string;
  employee_id?: string;
  date_from?: string;
  date_to?: string;
  sync_status?: string;
  page?: number;
  page_size?: number;
  sort?: string;
}
